export default __webpack_public_path__ + "navigation-examples-custom-server-v1-1200-4a3170238b5c556bd278dcbc999768b6.png";